import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const NotificationStatsStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "notification-stats",
})`
  display: flex;

  .NotificationStats-Item {
    padding: 0 5px;
  }
`;
